/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_TitleInputs */

const en_mk_calc_title = /** @type {(inputs: Mk_Calc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What your team costs per month`)
};

const id_mk_calc_title = /** @type {(inputs: Mk_Calc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berapa biaya tim Anda per bulan`)
};

/**
* | output |
* | --- |
* | "What your team costs per month" |
*
* @param {Mk_Calc_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_title = /** @type {((inputs?: Mk_Calc_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_title(inputs)
	return en_mk_calc_title(inputs)
});